export const chapter4Translations = {
  name: "第4章：磔刑と復活",
  description: "イエスの受難、死、そして復活の物語をたどる",
  spiritualWisdom: "十字架は愛の究極の勝利と罪に対する勝利の象徴です。復活は、キリストにある新しい命の約束を私たちに与えます。",
  
  levels: {
    40: {
      name: "逮捕",
      challenge: "ゲッセマネの園でのイエスの逮捕について学ぶ",
      
      questions: {
        easy: {
          question: "イエスはどこの園で逮捕されましたか？",
          options: ["ゲッセマネ", "エデン", "オリーブ", "ナザレ"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "ユダはイエスを裏切るためにどんな合図を使いましたか？",
          options: ["握手", "口づけ", "言葉", "身振り"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "どの弟子が剣で大祭司のしもべの耳を切り落としましたか？",
          options: ["ヤコブ", "ヨハネ", "ペテロ", "アンデレ"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "ゲッセマネはオリーブ山のふもとにある園です",
        "ユダは銀貨30枚でイエスを裏切りました",
        "イエスはしもべの耳を奇跡的に癒しました"
      ],
      
      funFacts: [
        "ゲッセマネは「油絞り」を意味し、オリーブ油が作られる場所でした",
        "イエスの逮捕は真夜中に起こりました",
        "イエスは平和的に行き、弟子たちに暴力で抵抗しないよう言いました"
      ]
    },

    41: {
      name: "ペテロの否認",
      challenge: "ペテロがイエスを三度否認したことについて学ぶ",
      
      questions: {
        easy: {
          question: "ペテロは何回イエスを否認しましたか？",
          options: ["1回", "2回", "3回", "4回"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "ペテロの3回目の否認の後に何が起こりましたか？",
          options: ["太陽が昇った", "鶏が鳴いた", "稲妻が光った", "地震が起きた"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "ペテロがイエスを否認したのはどこでしたか？",
          options: ["神殿で", "大祭司の中庭で", "ピラトの宮殿で", "ゲッセマネで"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "イエスはペテロの否認を予告していました",
        "ペテロは激しく泣いて悔い改めました",
        "すべて同じ夜に起こりました"
      ],
      
      funFacts: [
        "イエスは「鶏が鳴く前に、あなたは三度わたしを知らないと言うでしょう」と言いました",
        "ペテロの否認は人間の弱さと神の赦しの力強い例です",
        "ペテロは後に教会の偉大な指導者となりました"
      ]
    },

    42: {
      name: "ピラトの前のイエス",
      challenge: "ローマ総督の前でのイエスの裁判について学ぶ",
      
      questions: {
        easy: {
          question: "ピラトは誰でしたか？",
          options: ["弟子", "ローマ総督", "大祭司", "パリサイ人"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "ピラトはイエスに何を見いだせませんでしたか？",
          options: ["知恵", "罪", "勇気", "力"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "ピラトは自分の無実を象徴するために何をしましたか？",
          options: ["手を洗った", "衣を裂いた", "断食した", "祈った"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "ピラトはイエスを釈放したかったのです",
        "群衆はイエスの磔刑を要求しました",
        "ピラトは政治的圧力に屈しました"
      ],
      
      funFacts: [
        "ピラトの妻は彼にイエスに対して何もしないよう警告しました",
        "手を洗うことはユダヤの伝統で無実の象徴でした",
        "ピラトの決定は人間の正義の失敗を示しました"
      ]
    },

    43: {
      name: "バラバかイエスか",
      challenge: "群衆がバラバを選んだことについて学ぶ",
      
      questions: {
        easy: {
          question: "バラバは何者でしたか？",
          options: ["弟子", "強盗", "祭司", "王"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "ユダヤの祭りの間、ピラトは何ができましたか？",
          options: ["囚人を一人釈放する", "税を免除する", "宴会を開く", "神殿を閉じる"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "群衆は誰を選びましたか？",
          options: ["イエス", "バラバ", "両方", "誰も"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "過越の祭りの時でした",
        "群衆はイエスを十字架につけるよう要求しました",
        "バラバは殺人者で反逆者でした"
      ],
      
      funFacts: [
        "バラバという名前は「父の子」を意味します",
        "バラバの釈放はキリストの犠牲の象徴です",
        "私たちは皆バラバです、イエスの犠牲によって解放されました"
      ]
    },

    44: {
      name: "鞭打ちと茨の冠",
      challenge: "イエスの苦しみについて学ぶ",
      
      questions: {
        easy: {
          question: "兵士たちはイエスの頭に何を置きましたか？",
          options: ["金の冠", "茨の冠", "花の冠", "ターバン"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "兵士たちはどのようにイエスを嘲りましたか？",
          options: ["王と呼んで", "石を投げて", "牢に入れて", "無視して"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "ローマの鞭には何が含まれていましたか？",
          options: ["革の紐", "骨と金属の破片", "木だけ", "ロープ"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "鞭打ちは残酷なローマの刑罰でした",
        "兵士たちはイエスに紫の衣を着せました",
        "イエスはこれらすべてを静かに耐えました"
      ],
      
      funFacts: [
        "茨の冠は罪の呪いを象徴しています",
        "紫色は王の色で、嘲笑として使われました",
        "イエスの苦しみはイザヤの預言を成就します"
      ]
    },

    45: {
      name: "ゴルゴタへの道",
      challenge: "イエスが十字架を運んだことについて学ぶ",
      
      questions: {
        easy: {
          question: "イエスは何を運びましたか？",
          options: ["旗", "十字架", "冠", "剣"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "誰がイエスが十字架を運ぶのを助けましたか？",
          options: ["ペテロ", "ヨハネ", "クレネのシモン", "ヨセフ"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "ゴルゴタは何を意味しますか？",
          options: ["聖なる山", "されこうべの場所", "平和の場所", "正義の場所"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "イエスは弱って倒れました",
        "女性たちは道で泣いていました",
        "行列は町を通り抜けました"
      ],
      
      funFacts: [
        "十字架の重さは約40-50kgでした",
        "ゴルゴタは町の城壁の外にありました",
        "クレネのシモンはアフリカから来ました"
      ]
    },

    46: {
      name: "磔刑",
      challenge: "イエスの十字架刑について学ぶ",
      
      questions: {
        easy: {
          question: "イエスは他に何人と一緒に十字架につけられましたか？",
          options: ["誰もいない", "1人", "2人", "3人"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "イエスは十字架上で何と言いましたか：「父よ、彼らを___」？",
          options: ["救って", "赦して", "止めて", "罰して"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "十字架の上の銘は何でしたか？",
          options: ["罪人", "ユダヤ人の王", "反逆者", "預言者"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "イエスは昼の第三時に十字架につけられました",
        "兵士たちは彼の衣のためにくじを引きました",
        "イエスは十字架から七つの言葉を語りました"
      ],
      
      funFacts: [
        "銘は三つの言語で書かれていました：ヘブライ語、ラテン語、ギリシャ語",
        "一人の強盗が最後の瞬間に悔い改めました",
        "イエスは母の世話をヨハネに託しました"
      ]
    },

    47: {
      name: "イエスの死",
      challenge: "イエスの最後の時について学ぶ",
      
      questions: {
        easy: {
          question: "イエスの死の時に何が起こりましたか？",
          options: ["太陽が明るく輝いた", "暗闇が訪れた", "雨が降った", "虹が現れた"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "神殿で何が裂けましたか？",
          options: ["床", "幕", "壁", "天井"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "イエスの最後の言葉は何でしたか？",
          options: ["成し遂げられた", "渇く", "父よ、わが霊を御手に委ねます", "なぜ見捨てたのか"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "暗闇は三時間続きました",
        "兵士がイエスのわき腹を槍で刺しました",
        "百人隊長は「まことに、この人は神の子であった」と言いました"
      ],
      
      funFacts: [
        "神殿の幕は上から下まで裂けました、人の手によってではなく",
        "これは過越の時に起こりました、小羊が犠牲にされる時でした",
        "イエスの死は罪の代価を支払いました"
      ]
    },

    48: {
      name: "埋葬",
      challenge: "イエスの埋葬について学ぶ",
      
      questions: {
        easy: {
          question: "イエスは誰の墓に置かれましたか？",
          options: ["ペテロ", "アリマタヤのヨセフ", "ニコデモ", "ラザロ"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "イエスの体は何に包まれましたか？",
          options: ["紫の衣", "金の衣", "白い布", "何も着せず"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "ニコデモはイエスの体のために何を持ってきましたか？",
          options: ["油", "没薬とアロエ", "水", "花"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "墓は新しい岩に掘られていました",
        "大きな石が入口を塞ぎました",
        "番兵が墓を守るために配置されました"
      ],
      
      funFacts: [
        "これは金持ちの墓でした、イザヤの預言を成就して",
        "埋葬は急いで行われました、安息日が近づいていたからです",
        "ヨセフは秘密の弟子でしたが勇敢になりました"
      ]
    },

    49: {
      name: "空の墓",
      challenge: "復活の朝の発見について学ぶ",
      
      questions: {
        easy: {
          question: "誰が最初に墓が空であることを発見しましたか？",
          options: ["ペテロ", "ヨハネ", "女性たち", "兵士たち"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "石はどこにありましたか？",
          options: ["壊れていた", "転がされていた", "まだそこにあった", "消えていた"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "女性たちは墓で何人の天使に会いましたか？",
          options: ["誰もいない", "1人", "2人", "3人"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "週の最初の日の朝でした",
        "女性たちはイエスの体に油を塗るために来ました",
        "天使たちは良い知らせを告げました"
      ],
      
      funFacts: [
        "女性たちが最初の証人でした、革命的な詳細です",
        "ペテロとヨハネは墓まで走りました",
        "空の墓だけでは十分ではありませんでした、イエスが現れる必要がありました"
      ]
    },

    50: {
      name: "イエスがマグダラのマリアに現れる",
      challenge: "イエスの最初の出現について学ぶ",
      
      questions: {
        easy: {
          question: "復活後、イエスは最初に誰に現れましたか？",
          options: ["ペテロ", "ヨハネ", "マグダラのマリア", "トマス"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "マリアは最初イエスを誰だと思いましたか？",
          options: ["天使", "園丁", "兵士", "パリサイ人"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "マリアがイエスを認識した時、イエスは何と言いましたか？",
          options: ["行って伝えなさい", "わたしにすがりつくな", "恐れるな", "信じなさい"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "マリアは墓のそばで泣いていました",
        "イエスは彼女の名前を呼びました",
        "彼は彼女を兄弟たちに伝えるために送りました"
      ],
      
      funFacts: [
        "イエスは最初の出現のために女性を選びました",
        "マリアは最初の使徒となりました",
        "彼女は彼を「ラボニ」（先生）と呼びました"
      ]
    },

    51: {
      name: "エマオへの道で",
      challenge: "道でのイエスの出現について学ぶ",
      
      questions: {
        easy: {
          question: "何人の弟子がエマオへ行っていましたか？",
          options: ["1人", "2人", "3人", "4人"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "弟子たちはいつイエスを認識しましたか？",
          options: ["すぐに", "パンを裂いた時", "道で", "決して認識しなかった"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "イエスは道で彼らに何を説明しましたか？",
          options: ["未来", "聖書", "律法", "奇跡"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "イエスは見知らぬ人として彼らと共に歩きました",
        "彼が話す間、彼らの心は燃えていました",
        "彼らが認識した時、イエスは姿を消しました"
      ],
      
      funFacts: [
        "エマオはエルサレムから約11km離れていました",
        "イエスはすべての聖書が彼について語っていることを示しました",
        "弟子たちはすぐにエルサレムへ走って戻りました"
      ]
    },

    52: {
      name: "弟子たちへの出現",
      challenge: "閉じられた部屋でのイエスの出現について学ぶ",
      
      questions: {
        easy: {
          question: "イエスが現れた時、弟子たちはどこにいましたか？",
          options: ["神殿で", "市場で", "閉じられた部屋で", "ゲッセマネで"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "イエスは弟子たちに何を見せましたか？",
          options: ["彼の傷", "彼の顔", "彼の衣", "光"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "最初の時、どの弟子がいませんでしたか？",
          options: ["ペテロ", "ヨハネ", "トマス", "ヤコブ"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "扉は恐れのために閉じられていました",
        "イエスは「平安があなたがたにあるように」と言いました",
        "彼は彼らに息を吹きかけて「聖霊を受けなさい」と言いました"
      ],
      
      funFacts: [
        "イエスは幽霊ではないことを証明するために彼らと食事をしました",
        "トマスは一週間後に信じました",
        "イエスは40日間、何度も現れました"
      ]
    }
  }
};
